import React, { useEffect, useMemo, useState } from "react";
import knowledgeBase from "./knowledgeBase";



const DiagnosisResults = ({ answers, onDiseasesDetected }) => {
    // Calcular scoreMap cada vez que cambian las respuestas
    const scoreMap = useMemo(() => {
        const scores = {};
        if (!answers) return scores;

        Object.entries(answers).forEach(([symptom, qAndA]) => {
            Object.values(qAndA).forEach((answer) => {
                knowledgeBase.forEach(({ disease, relatedAnswers }) => {
                    if (relatedAnswers.includes(answer) || relatedAnswers.includes(symptom)) {
                        scores[disease] = (scores[disease] || 0) + 1;
                    }
                });
            });
        });

        return scores;
    }, [answers]);

    // Ordenar las enfermedades por puntaje
    const sortedDiseases = useMemo(() => {
        return Object.entries(scoreMap)
            .sort((a, b) => b[1] - a[1])
            .map(([disease]) => disease);
    }, [scoreMap]);

    // Notificar las enfermedades detectadas (opcional)
    useEffect(() => {
        if (onDiseasesDetected) onDiseasesDetected(sortedDiseases);
    }, [sortedDiseases, onDiseasesDetected]);

    // Modal y funciones para mostrar similares
    const [modalOpen, setModalOpen] = useState(false);
    const [modalDisease, setModalDisease] = useState(null);

    const openModal = (disease) => {
        setModalDisease(disease);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setModalDisease(null);
    };

    const getSimilarDiseases = (disease) => {
        const diseaseInfo = knowledgeBase.find((d) => d.disease === disease);
        if (!diseaseInfo || !diseaseInfo.similarDiseases) return [];
        return diseaseInfo.similarDiseases.map((sim) =>
            knowledgeBase.find((d) => d.disease === sim)
        );
    };

    if (!answers || Object.keys(answers).length === 0) return null;

    return (
        <div style={{ paddingTop: "20px" }}>
            <h2>Diagnóstico probable</h2>
            {sortedDiseases.length === 0 ? (
                <p>No se pudo determinar un diagnóstico con los datos proporcionados.</p>
            ) : (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        marginTop: "15px",
                    }}
                >
                    {sortedDiseases.map((disease, i) => {
                        const info = knowledgeBase.find((k) => k.disease === disease);
                        if (!info) return null;

                        return (
                            <div
                                key={i}
                                style={{
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.12)",
                                    borderRadius: "10px",
                                    padding: "15px 20px",
                                    backgroundColor: "white",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                    elevation: 5,
                                }}
                            >
                                <h3 style={{ margin: 0 }}>{info.disease}</h3>
                                <p style={{ margin: 0, color: "#555" }}>{info.description}</p>
                                <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                                    <a
                                        href={info.infoUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            backgroundColor: "#007bff",
                                            color: "white",
                                            padding: "8px 14px",
                                            borderRadius: "25px",
                                            textDecoration: "none",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Más información
                                    </a>
                                    <button
                                        onClick={() => openModal(info.disease)}
                                        style={{
                                            backgroundColor: "#6c757d",
                                            color: "white",
                                            padding: "8px 14px",
                                            borderRadius: "25px",
                                            border: "none",
                                            cursor: "pointer",
                                            fontWeight: "600",
                                        }}
                                    >
                                        Otros similares
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            {modalOpen && modalDisease && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                    onClick={closeModal}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: "white",
                            borderRadius: "12px",
                            padding: "20px",
                            width: "90%",
                            maxWidth: "400px",
                            maxHeight: "80vh",
                            overflowY: "auto",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        }}
                    >
                        <h3>Enfermedades similares a {modalDisease}</h3>
                        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                            {getSimilarDiseases(modalDisease).length === 0 && (
                                <li>No se encontraron enfermedades similares.</li>
                            )}
                            {getSimilarDiseases(modalDisease).map((disease, i) => (
                                <li
                                    key={i}
                                    style={{
                                        padding: "8px 0",
                                        borderBottom: "1px solid #ddd",
                                        fontWeight: "600",
                                    }}
                                >
                                    {disease.disease}
                                    <p style={{ margin: "4px 0", color: "#666" }}>
                                        {disease.description}
                                    </p>
                                    <a
                                        href={disease.infoUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            color: "#007bff",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Más información
                                    </a>
                                </li>
                            ))}
                        </ul>
                        <button
                            onClick={closeModal}
                            style={{
                                marginTop: "15px",
                                backgroundColor: "#007bff",
                                color: "white",
                                borderRadius: "25px",
                                padding: "8px 14px",
                                border: "none",
                                cursor: "pointer",
                                fontWeight: "600",
                            }}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DiagnosisResults;
